module.exports = __webpack_public_path__ + "static/media/DSC_0154.278d4ff7.jpg";